import { useEffect, useState } from 'react';
import { useSearchParams, useLocation } from 'react-router-dom';
import { useSchedulesByEvent } from 'useCases/schedules';
import { useTranslate } from 'hooks';
import { useFormatDate } from 'hooks/useFormatDate';
import { dateFormatHandler } from 'lib/contexts/date';
import { ScheduleList } from 'pages/schedule/ScheduleList/ScheduleList';
import { Container, Spinner, ButtonGroup } from 'components/structure';
import * as S from './Schedule.styles';

export const Schedule = () => {
  // const session = useRealTimeSession();
  const { pathname } = useLocation();
  const pathnameSchedule = pathname.split('/')[1];
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedDateParams = searchParams.get('selectedDate');
  const [selectedDate, setSelectedDate] = useState(selectedDateParams ?? '');
  const translate = useTranslate();
  const { data: scheduleData, isLoading } = useSchedulesByEvent();
  const dates = useFormatDate(scheduleData?.eventDays.map((x) => x.date) || []);
  useEffect(() => {
    if (selectedDateParams) {
      return;
    }

    const initialDate = scheduleData?.eventDays[0].date;

    if (initialDate) {
      setSelectedDate(dateFormatHandler(initialDate));
    }
  }, [selectedDateParams, scheduleData?.eventDays]);

  useEffect(() => {
    if (selectedDate) {
      setSearchParams({ selectedDate });
    }
  }, [setSearchParams, selectedDate]);

  const handleSelectDate = (value: string) => setSelectedDate(value);

  if (!selectedDate || isLoading) {
    return <Spinner />;
  }

  const streamGroups = scheduleData?.eventDays?.find(
    (x) => dateFormatHandler(x.date) === selectedDate,
  )?.streamGroups;

  return (
    <Container shedule={pathnameSchedule}>
      <S.Container>
        <S.Content>
          <S.Title>{translate('schedule.title')}</S.Title>
          <ButtonGroup
            onChange={handleSelectDate}
            value={selectedDate}
            options={dates}
          />
          <ScheduleList
            isLoading={isLoading}
            streamGroups={streamGroups || []}
          />
          {/* if abaixo especifico para maryKay */}
          {(selectedDate === '2024-01-25' || selectedDate === '2024-01-26') && (
            <S.BoxWarning>
              <S.Warning>
                * Esse conteúdo é exclusivo do evento ao vivo, não será possível
                assistir posteriormente pois ele não ficará gravado. Não perca!
              </S.Warning>
              <S.Warning>
                **Essa agenda pode ser alterada a qualquer momento, sem aviso
                prévio.
              </S.Warning>
            </S.BoxWarning>
          )}
        </S.Content>
      </S.Container>
      {/* <S.aboutName>
        Blazek O, et al. Am Heart J Plus 2022;19:100187<br/>
				PP-KER-BR-0071-1
        <img src={Rodape} alt="" />
      </S.aboutName> */}
    </Container>
  );
};
